import { Outlet } from "react-router-dom";
import { Container, Box, useMediaQuery, useTheme } from "@mui/material";
import { Header } from "./Header";
import { MobileNavigation } from "./MobileNavigation";

export const Layout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box>
      <Header />
      <Container
        maxWidth="lg"
        sx={{
          mt: 4,
          pb: isMobile ? "calc(56px + env(safe-area-inset-bottom) + 16px)" : 4,
        }}
      >
        <Outlet />
      </Container>
      {isMobile && <MobileNavigation />}
    </Box>
  );
};
